import React from "react";
import axios from "axios";
import { Link as ScrollLink } from "react-scroll";
import AOS from "aos";
import "aos/dist/aos.css";
import moment from "moment";
import "moment/locale/id";
import ut from "assets/img/utskul.png";
import klinik from "assets/img/klikprt.png";
import dcare from "assets/img/BABIES & KIDS CARE UNIT (1).png";
import Bencana from "assets/img/Logo Karya Bakti/Bencana.png";
import Kesehatan from "assets/img/Logo Karya Bakti/Kesehatan.png";
import Pendidikan from "assets/img/Logo Karya Bakti/Pendidikan.png";
import Kreatif from "assets/img/Logo Karya Bakti/Kreatif.png";
import Lingkungan from "assets/img/Logo Karya Bakti/Lingkungan.png";
import marsVideo from "assets/vidio-mars/MARS_YKBUT.mp4";
import { Container, Row, Col } from "reactstrap";
import ExamplesNavbar from "../../components/Navbars/ExamplesNavbar";
import LandingPageHeader from "../../components/Headers/LandingPageHeader";
import DefaultFooter from "../../components/Footers/DefaultFooter";
// import { Icon } from "@iconify/react";

// === fungsi fetch flipbooks ===
const getFlipbooks = async () => {
    const API_KEY = "81df3828de7ac7e5db8517b55ee83ed79a48ebe7.6d678a06d72a2829";
    try {
        const response = await axios.get("https://heyzine.com/api1/flipbook-list", {
            headers: {
                Authorization: `Bearer ${API_KEY}`,
            },
        });

        // filter hanya yang mengandung "YKBUT MAGAZINE"
        const filtered = response.data.filter(
            (item) =>
                typeof item.title === "string" &&
                item.title.toUpperCase().includes("YKBUT MAGAZINE")
        );

        // urutkan berdasarkan tanggal terbaru
        const sorted = filtered.sort((a, b) => new Date(b.date) - new Date(a.date));

        return sorted;
    } catch (error) {
        console.error("Error fetching flipbooks:", error);
        return [];
    }
};

function LandingPage() {
    const [flipbooks, setFlipbooks] = React.useState([]);
    const [loadingFlipbook, setLoadingFlipbook] = React.useState(true);

    React.useEffect(() => {
        AOS.init({ duration: 1000, once: true });
        document.body.classList.add("landing-page", "sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;

        const fetchFlipbooks = async () => {
            setLoadingFlipbook(true);
            const mags = await getFlipbooks();
            setFlipbooks(mags);
            setLoadingFlipbook(false);
        };
        fetchFlipbooks();

        return function cleanup() {
            document.body.classList.remove("landing-page", "sidebar-collapse");
        };
    }, []);

    return (
        <>
            <ExamplesNavbar />
            <div className="wrapper">
                <LandingPageHeader />

                {/* === SEKILAS YAYASAN === */}
                <div className="section section-about-us" data-aos="fade-in">
                    <Container>
                        <Row>
                            <Col className="ml-auto mr-auto text-center" md="8">
                                <h2 className="title" data-aos="fade-left">
                                    Sekilas Yayasan
                                </h2>
                                <h5 className="description" data-aos="fade-right">
                                    Yayasan Karya Bakti United Tractors (YKBUT) didirikan oleh PT
                                    United Tractors Tbk (UT) pada 27 Februari 2008. Menciptakan
                                    Sumber Daya Manusia yang...
                                    <a href="/about" smooth={true} duration={500}>
                                        <button className="btn btn-primary mt-3" data-aos="fade-up">
                                            Read More
                                        </button>
                                    </a>
                                </h5>
                            </Col>
                        </Row>

                        <div className="separator separator-primary"></div>
                        <div className="section-story-overview">
                            <Row>
                                <Col md="6">
                                    <video
                                        width="100%"
                                        height="300px"
                                        controls
                                        data-aos="fade-right"
                                    >
                                        <source src={marsVideo} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                </Col>
                                <Col md="5">
                                    <h3 data-aos="fade-left">PROGRAM KARYA BAKTI</h3>
                                    <p data-aos="fade-left" data-aos-delay="220">
                                        <img
                                            src={Pendidikan}
                                            alt="Icon"
                                            style={{
                                                width: "50px",
                                                height: "50px",
                                                marginLeft: "10px",
                                            }}
                                        />
                                        KARYA BAKTI PENDIDIKAN
                                    </p>
                                    <p data-aos="fade-left" data-aos-delay="240">
                                        <img
                                            src={Kesehatan}
                                            alt="Icon"
                                            style={{
                                                width: "50px",
                                                height: "50px",
                                                marginLeft: "10px",
                                            }}
                                        />
                                        KARYA BAKTI KESEHATAN
                                    </p>
                                    <p data-aos="fade-left" data-aos-delay="260">
                                        <img
                                            src={Lingkungan}
                                            alt="Icon"
                                            style={{
                                                width: "50px",
                                                height: "50px",
                                                marginLeft: "10px",
                                            }}
                                        />
                                        KARYA BAKTI LINGKUNGAN
                                    </p>
                                    <p data-aos="fade-left" data-aos-delay="280">
                                        <img
                                            src={Kreatif}
                                            alt="Icon"
                                            style={{
                                                width: "50px",
                                                height: "50px",
                                                marginLeft: "10px",
                                            }}
                                        />
                                        KARYA BAKTI KREATIVITAS SOSIAL
                                    </p>
                                    <p data-aos="fade-left" data-aos-delay="300">
                                        <img
                                            src={Bencana}
                                            alt="Icon"
                                            style={{
                                                width: "50px",
                                                height: "50px",
                                                marginLeft: "10px",
                                            }}
                                        />
                                        KARYA BAKTI PEDULI BENCANA
                                    </p>
                                </Col>
                            </Row>
                        </div>
                    </Container>
                </div>

                {/* === MAGAZINE SECTION (Bootstrap version) === */}
                <div
                    className="section py-5"
                    data-aos="fade-up"
                    style={{
                        background: "linear-gradient(135deg, #f5f8fc 0%, #ffffff 100%)",
                    }}
                >
                    <Container>
                        {/* Header */}
                        <div className="d-flex align-items-center mb-4" style={{ gap: "8px" }}>
                            <h2
                                className="title mb-0"
                                style={{
                                    fontWeight: 800,
                                    fontSize: "2rem",
                                    color: "#1F2937",
                                }}
                            >
                                YKBUT MAGAZINE
                            </h2>
                        </div>

                        {/* Loading Skeleton */}
                        {loadingFlipbook ? (
                            <div
                                className="d-flex flex-row overflow-auto pb-3"
                                style={{ gap: "20px" }}
                            >
                                {[...Array(4)].map((_, index) => (
                                    <div
                                        key={index}
                                        className="bg-white rounded shadow-sm"
                                        style={{
                                            width: "200px",
                                            overflow: "hidden",
                                            flex: "0 0 auto",
                                        }}
                                    >
                                        <div
                                            style={{
                                                backgroundColor: "#e5e7eb",
                                                height: "270px",
                                                width: "100%",
                                                animation: "pulse 1.5s infinite",
                                            }}
                                        />
                                        <div className="p-3">
                                            <div
                                                style={{
                                                    height: "10px",
                                                    width: "70%",
                                                    backgroundColor: "#e5e7eb",
                                                    borderRadius: "4px",
                                                    animation: "pulse 1.5s infinite",
                                                    marginBottom: "8px",
                                                }}
                                            />
                                            <div
                                                style={{
                                                    height: "10px",
                                                    width: "40%",
                                                    backgroundColor: "#e5e7eb",
                                                    borderRadius: "4px",
                                                    animation: "pulse 1.5s infinite",
                                                }}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : flipbooks?.length > 0 ? (
                            <div
                                className="d-flex flex-row overflow-auto pb-3"
                                style={{
                                    gap: "24px",
                                    scrollbarWidth: "none",
                                    msOverflowStyle: "none",
                                }}
                            >
                                {flipbooks.map((fb, index) => (
                                    <a
                                        key={index}
                                        href={fb.links?.custom || fb.links?.base}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-decoration-none text-dark"
                                        style={{
                                            flex: "0 0 auto",
                                            width: "200px",
                                            borderRadius: "12px",
                                            backgroundColor: "#fff",
                                            boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
                                            overflow: "hidden",
                                            transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = "translateY(-4px)";
                                            e.currentTarget.style.boxShadow =
                                                "0 8px 20px rgba(0,0,0,0.15)";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = "translateY(0)";
                                            e.currentTarget.style.boxShadow =
                                                "0 4px 10px rgba(0,0,0,0.08)";
                                        }}
                                    >
                                        <div
                                            style={{
                                                position: "relative",
                                                width: "100%",
                                                aspectRatio: "3 / 4",
                                                backgroundColor: "#f3f4f6",
                                                overflow: "hidden",
                                            }}
                                        >
                                            <img
                                                src={fb.links?.thumbnail}
                                                alt={fb.title}
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                }}
                                            />
                                        </div>
                                        <div className="p-3">
                                            <h5
                                                className="mb-1"
                                                style={{
                                                    fontSize: "0.9rem",
                                                    fontWeight: "600",
                                                    lineHeight: "1.3",
                                                    height: "38px",
                                                    overflow: "hidden",
                                                }}
                                            >
                                                {fb.title || "Untitled"}
                                            </h5>
                                            <p
                                                className="text-muted mb-0"
                                                style={{
                                                    fontSize: "0.8rem",
                                                }}
                                            >
                                                {moment(fb.date).format("DD MMM YYYY")}
                                            </p>
                                        </div>
                                    </a>
                                ))}
                            </div>
                        ) : (
                            <p
                                className="text-muted text-center mt-4"
                                style={{
                                    fontSize: "1rem",
                                    color: "#6c757d",
                                }}
                            >
                                Tidak ada majalah ditemukan.
                            </p>
                        )}
                    </Container>
                </div>

                {/* === UNIT OPERASIONAL === */}
                <div className="section section-team text-center" data-aos="fade-up">
                    <Container>
                        <h2 className="title">UNIT OPERASIONAL</h2>
                        <div className="team">
                            <Row>
                                <Col md="4" className="text-center">
                                    <div className="team-player">
                                        <img
                                            alt="UT School"
                                            className="img-fluid"
                                            src={ut}
                                            style={{
                                                maxWidth: "250px",
                                                height: "auto",
                                                marginBottom: "20px",
                                            }}
                                        />
                                        <h4 className="title">UT SCHOOL</h4>
                                        <p className="description">
                                            <a href="/utschool">See Details</a>
                                        </p>
                                    </div>
                                </Col>
                                <Col md="4" className="text-center">
                                    <div className="team-player">
                                        <img
                                            alt="Klinik Pratama"
                                            className="img-fluid"
                                            src={klinik}
                                            style={{
                                                maxWidth: "250px",
                                                height: "auto",
                                                marginBottom: "20px",
                                            }}
                                        />
                                        <h4 className="title">KLINIK PRATAMA UT</h4>
                                        <p className="description">
                                            <a href="/klinik-pratama">See Details</a>
                                        </p>
                                    </div>
                                </Col>
                                <Col md="4" className="text-center">
                                    <div className="team-player">
                                        <img
                                            alt="D'CARE"
                                            className="img-fluid"
                                            src={dcare}
                                            style={{
                                                maxWidth: "250px",
                                                height: "auto",
                                                marginBottom: "20px",
                                            }}
                                        />
                                        <h4 className="title">UT D'CARE</h4>
                                        <p className="description">
                                            <a href="/dcare">See Details</a>
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Container>
                </div>

                <DefaultFooter />
            </div>
        </>
    );
}

export default LandingPage;
